import { Component, ElementRef, Input, OnChanges, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-read-more',
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReadMoreComponent implements OnInit, OnChanges {

  @ViewChild('text') textspan!: ElementRef;
  @Input() length = 50;
  @Input() cssClass?= '';
  @Input() textValue: string = '';
  outputText: string = '';
  shortened: boolean = true;

  constructor() { }

  ngOnInit() {
    this.updateText();
  }

  ngOnChanges() {
    this.updateText();
  }

  updateText() {
    if (this.shortened && this.textValue && this.textValue.length > this.length) {
      const shortenedValue = this.textValue.substr(0, this.length);
      this.outputText = shortenedValue;
      this.shortened = true;
      return;
    }

    this.shortened = false;
    this.outputText = this.textValue;
  }

  expand() {
    this.shortened = false;
    this.updateText();
  }
}
